import axios from "axios"
import { ApiUrls } from '../../constants/Activation/apiUrls';
import { getTransactionId } from "../transactionId";

/**
 * call api to get the details for the activation page
 * @param   {object} payload  Api payload consisting of activationToken, activationId and productId
 * @return  {object}          Api response
 */
export const getActivationDetails = (payload, token) =>
{
  const url = ApiUrls.activation.getActivationInfo
  return axios.request({
    method: 'POST',
    url,
    data: payload,
    withCredentials: true,
    headers: {
      'X-CSRF-Token': token,
      "X-Transaction-ID": getTransactionId(),
    }
  })
}
